export default "__VITE_ASSET__DQdbNgV___"